<script setup>
import { computed } from 'vue';
import 'highlight.js/styles/default.css';
import 'highlight.js/lib/common';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store.js';

import Button from 'next/button/Button.vue';

const props = defineProps({
  result: {
    type: [String, Number, Boolean, Object, Array],
    default: null,
  },
  hasError: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['test']);
const { t } = useI18n();

const uiFlags = useMapGetter('wgptMcpServers/getUIFlags');

const hasResult = computed(
  () => props.result !== null && props.result !== undefined
);

const textResult = computed(() => {
  if (typeof props.result === 'object') {
    return JSON.stringify(props.result, null, 2);
  }
  return String(props.result);
});
</script>

<template>
  <div class="space-y-4">
    <div class="flex items-center justify-between">
      <label
        class="mb-0.5 text-sm font-medium text-n-slate-12 flex flex-col gap-1 relative"
      >
        {{ t('WGPT_MCP_SERVERS.EDIT.TOOLS.TEST_TOOL.RESULTS_LABEL') }}
      </label>
    </div>

    <Button
      slate
      sm
      :is-loading="uiFlags.isTesting"
      :disabled="uiFlags.isTesting"
      color="blue"
      :label="t('WGPT_MCP_SERVERS.EDIT.TOOLS.TEST_TOOL.TEST_BUTTON_LABEL')"
      @click="emit('test')"
    />

    <highlightjs
      v-if="hasResult"
      language="javascript"
      :code="textResult"
      class="[&_code]:text-start min-h-4"
      :class="
        hasError ? '[&_code]:!bg-n-ruby-5/50' : '[&_code]:!bg-n-teal-5/50'
      "
    />
    <p v-else class="px-6 py-10 text-sm leading-6 text-center text-n-slate-11">
      {{ t('WGPT_MCP_SERVERS.EDIT.TOOLS.TEST_TOOL.RESULTS_PLACEHOLDER') }}
    </p>
  </div>
</template>
